import _ from 'lodash';
import Vue from 'vue'

//_.mixin({
  // json: function(str) {
  //   return _.isString(str) ? JSON.parse(str) : JSON.stringify(str)
  // },
  // push: function(arr, values) {
  //   arr.push(...values);
  //   return arr;
  // },
  // height: function(el, value) {
  //   return _.isNil(value) ? helper.prop(el, "height", value) : _.set(el, "style.height", `${value}px`)
  // },
  // prop: function(item, prop, value) {
  //   return _.isNil(value) ? _.get(item, prop) : _.set(item, prop, value)
  // },
  // on: function(el, event, fn) {
  //   if (_.isString(el)) {
  //     fn = event
  //     event = el
  //     el = window
  //   }
  //   el.addEventListener(event, _.throttle(fn, 500))
  // }
//})

Vue.mixin({
  computed: {
    "_": function() {
      return _;
    }
  }
});
